// File: ProfileMetrics.js
import React from "react";
import AssessmentProfileService from "../../services/AssessmentProfileService";
import MetricItem from "./MetricItem";
import DifficultyMeter from "./DifficultyMeter";

const ProfileMetrics = ({ parameters }) => {
  return (
    <div className="mt-4 space-y-2">
      <MetricItem label="Duration" value={`${parameters.duration} min`} />
      <MetricItem
        label="Questions"
        value={`${parameters.question_count} questions`}
      />
      <DifficultyMeter
        level={parameters.difficulty_level}
        label={AssessmentProfileService.difficultyLevel(
          parameters.difficulty_level,
        )}
      />
    </div>
  );
};

export default ProfileMetrics;
